import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { NavLink } from 'react-router-dom';

import { Icon } from 'src/components/icon';

import styles from './AsideItemRow.module.scss';


type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	text: string;
	icon: string;
	value: boolean;
	href: string;
};

export function AsideItemRow(props: TProps) {
	const {
		text,
		icon,
		value,
		href,
		className: classNameOuter,
	} = props;

	const classNames = [styles.box];
	if (classNameOuter) {
		classNames.push(classNameOuter);
	}

	if (value) {
		classNames.push(styles.active);
	}

	return (
		<NavLink
			className={ classNames.join(' ') }
			to={ href }
		>
			<Icon icon={ icon } className={ styles.iconLink }/>
			{ text }
		</NavLink>
	);
}
